module.exports = __webpack_public_path__ + "static/video-c37fac0f52c91d3aec10bb1f632bae33.mp4";